import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

export const StyledStoreInfoList = styled.ul`
  list-style-position: inside;
  margin-bottom: ${layout.measurements.spacing050};
`;

export const StyledStoreInfoText = styled.li(
  props => css`
    color: ${props.theme.text.secondary};
  `
);
